export default __webpack_public_path__ + "static/media/ainqa_logo_black.b836dca1.svg";